/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RemoveCommentRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
